module.exports = __webpack_public_path__ + "img/picture_bms1.c02b5422.jpg";